/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useEditProjectFormStyles = makeStyles(() => ({
  title: {
    margin: '0 8px 12px',
  },
  buttons: {
    padding: '20px 0',
    position: 'sticky',
    background: 'rgba(255,255,255,0.8)',
    bottom: '0',
    display: 'flex',
    margin: '0 -7px',
  },
  buttonWrap: {
    padding: '0 7px',
  },
  formControl: {
    width: '360px',
    marginTop: '10px',
    '&:first-child': {
      marginTop: 0,
    },
  },
}));
